import { render, staticRenderFns } from "./MembersList.vue?vue&type=template&id=27eb194c&"
import script from "./MembersList.vue?vue&type=script&lang=js&"
export * from "./MembersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports